import React from 'react';
import { string, func, bool, number } from 'prop-types';
import classnames from 'classnames';
import { Icons, Image } from 'components';
import { multipleFiltersAttributesShape } from 'shapes';
import { useEnvironmentData } from 'hooks';

export default function Pastille({
    className,
    name,
    url,
    pictureUrl,
    active,
    attributes,
    position,
    id,
    onSelectPastille,
}) {
    const { cdn } = useEnvironmentData();
    const handleClick = event => {
        event.preventDefault();
        onSelectPastille(event, { attributes, position, name, id });
    };

    const rootClassnames = classnames(
        'promoted-filters-step__pastille',
        className,
        {
            'promoted-filters-step__pastille--active': active,
        },
    );

    return (
        <a
            className={rootClassnames}
            href={url}
            onClick={handleClick}
            onKeyPress={handleClick}
        >
            <div className="promoted-filters-step__pastille__circle">
                <Image
                    className="promoted-filters-step__pastille__circle__img"
                    alt={`${name} pastille`}
                    src={pictureUrl}
                    cdn={cdn}
                />
                <div className="promoted-filters-step__pastille__circle__overlay" />
                <Icons.Check className="promoted-filters-step__pastille__active-icon" />
            </div>

            <span className="promoted-filters-step__pastille__name">
                {name}
            </span>
        </a>
    );
}

Pastille.propTypes = {
    className: string,
    attributes: multipleFiltersAttributesShape.isRequired,
    active: bool,
    name: string.isRequired,
    pictureUrl: string,
    url: string,
    onSelectPastille: func.isRequired,
    position: number,
    id: number.isRequired,
};

Pastille.defaultProps = {
    className: null,
    url: '',
    pictureUrl: null,
    active: false,
    position: -1,
};
